import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Claimants } from '../../models/claimant';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonModule } from '@angular/common';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Authenticate } from '../../models/authenticate';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';

type StateItem = { Id: string; Name: string };

@Component({
  selector: 'app-file-noticed',
  imports: [CommonModule, ReactiveFormsModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
  templateUrl: './file-noticed.html',
  styleUrl: './file-noticed.css',
})

@Injectable({
  providedIn: 'root' // Add this line for LocalStorageService
})

export class FileNoticed implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  datePickerConfig: Partial<BsDatepickerConfig>;

  submitted = false;
  clicked = false;
  clickedOnce = false;
  /*isChecked = false;*/
  authenticatedUser: Authenticate;
  addButtonClicked = false;
  allStates: any = [];
  allCountries: any = [];
  allHours: any = [];
  allDocumentationTypes: any = [];
  claimantsInformation: FormGroup;
  oopeList: any = [];
  submittedClaim: Claimants;
  showDivForUS: boolean = false;
  showDivForNonUS: boolean = false;
  showDivCaliforniaResident: boolean = false;
  showDivUploadDocumentMessage: boolean = false;
  showDivIllinoisInformation: boolean = false;
  response: string | undefined;
  minDate: Date;
  supportingDocuments: File[] = [];
  calculatedValue: any;
  dateLoaded: Date;
  claimStartTime: Date;
  claimEndTime: Date;

  validation_FormErrorMessages = {
    phone1: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 10 digits" },
      { type: "maxlength", message: "This field must not be at greater 10 digits<" },
      { type: "pattern", message: "Only use numbers" }
    ],
    name1: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 digits" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    lastName: [
      { type: "required",  message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    street1: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    city: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 40 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    state: [
      { type: "required", message: "This field is required" },
    ],
    signature: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 digits" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    emailAddress: [
      { type: "required", message: "This field is required" },
      { type: "maxlength", message: "This field must not be at greater 255 characters" },
      { type: "pattern", message: "This is not a valid email address" }
    ],
    zip: [
      { type: "required", message: "This field is required" },
      { type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    acknowledgement: [
      { type: "required", message: "This field is required" }
      //{ type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    googleRecaptchaToken: [
      { type: "required", message: "This field is required" }
      //{ type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
  };


  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService) { }

  ngOnInit() {
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.claimStartTime = new Date();
    this.loadAllStates();
    this.claimantsInformation = this.fb.group({
      name1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phone1: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      acknowledgement: [false, Validators.compose([Validators.requiredTrue])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
    });
  }

  loadAllStates() {
    this.httpClient.get("/assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }
  get f() { return this.claimantsInformation.controls; }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  getCaliforniaResidentValue($event) {
    /*this.changed = true;*/
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value === 'No') {
      this.showDivCaliforniaResident = false;
    }
    else {
      this.showDivCaliforniaResident = true
    }
  }

  onSubmit() {
    this.submitted = true;
    this.claimEndTime = new Date();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.wasClaimantNoticed = true;
    /*claimant.noticeId = this.authenticatedUser.noticeId;*/
    claimant.uniqueId = this.authenticatedUser.uniqueId;
    claimant.noticeId = this.authenticatedUser.noticeId;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    //var OriginalEmail = this.authenticatedUser.emailAddress;
    //var ChangedEmail = this.claimantsInformation.get('emailAddress').value;

    //if (OriginalEmail !== ChangedEmail) {
    //  claimant.EmailFlag = 'EMACH';
    //}



    this.spinner.show();

    /*console.log(claimant);*/
    // this.CreateClaimant(claimant);


    // Single API call
    this.claimantService.createClaimant(claimant).subscribe({
      next: (res) => {
        this.storage.store('claimant', res);
        this.claimantsInformation.reset();
        this.spinner.hide();
        this.router.navigate(['/complete']);
      },
      error: err => {
        this.spinner.hide();
        console.group('Claimant submission failed');
        console.log('Status:', err.status);
        console.log('Error:', err.error);
        console.groupEnd();
      }
    });
  }

  // CreateClaimant(claimant: Claimants) {
  //   this.claimantService.createClaimant(claimant).subscribe(res => {
  //     this.submittedClaim = res;
  //     this.storage.store('claimant', this.submittedClaim);
  //     this.submitted = false;
  //     this.claimantsInformation.reset();
  //     this.spinner.hide();
  //     this.router.navigate(['/complete']);
  //   });
  // }
}
